/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORTS : DIRECT DEPOSIT : STYLES --------------- ++++++++++ */
export default theme =>({
    directDeposit:{
        '& .griditem': {
            maxWidth: pxToEm(310),
            width: '100%',
            marginRight: pxToEm(30),
            marginTop: pxToEm(20),
            '& .field':{
                maxWidth: pxToEm(310),
                width: '100%'
            }
        }
    }
});
